export var SwapMode;
(function (SwapMode) {
    SwapMode["ExactIn"] = "ExactIn";
    SwapMode["ExactOut"] = "ExactOut";
})(SwapMode || (SwapMode = {}));
Object.setPrototypeOf(SwapMode, null);
